import React from 'react'
import styles from './index.module.less'

export default ({ style }) => {
  return <div className={styles.mouseIcon} style={style}>
    <img className="mouseIconImg" src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendationImage01/mouseIcon.png" />
  </div>
}
